import { dynamicPhoneMask } from '../utils/phone'
import { PHONE_INPUT_DEFAULTS_KEY } from '@core/types'

export default defineNuxtPlugin({
    name: 'phone-input',
    parallel: true,
    dependsOn: ['rules'],
    setup(nuxtApp) {
        const { PHONE } = useRules()
        nuxtApp.vueApp.provide(PHONE_INPUT_DEFAULTS_KEY, {
            rules: PHONE,
            mask: dynamicPhoneMask,
        })
    }
})
